import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TipWrapper = styled.div`
    margin-bottom: 16px;
    margin-left: 16px;
    display: flex;
    align-items: center;

    .udesk-qa-ui-btn {
        padding-left: 8px;
        &:hover {
            color: #458fff;
        }
    }
`;

export const FormWrapper = styled.div`
    margin-bottom: 16px;
    max-width: 800px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
`;

export const Logo = styled.div`
    flex: 0 0 150px;
`;
